(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heartsave-pocket-prelaunch"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hp-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-hp-slide]');
    const thumbs = gallery.querySelectorAll('[data-hp-thumb]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const selectedIndex = thumb.dataset.hpThumb;

        slides.forEach((slide) => {
          const active = slide.dataset.hpSlide === selectedIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });

        thumbs.forEach((item) => {
          const active = item.dataset.hpThumb === selectedIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
